import { Component, OnInit, ViewChild } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { ToastService } from 'ng-uikit-pro-standard';
import { FormatoProductosService } from 'src/app/services/formato-productos.service';
import { MessageRendererService } from 'src/app/services/message-renderer.service';
import { TipoDTEService } from 'src/app/services/tipo-dte.service';
import { ConsoleService } from 'src/app/shared/services/console.service';
import { GraphQLClient } from 'src/app/shared/services/graph-qlclient.service';
import { SecurityService } from 'src/app/shared/services/security.service';
import { ModalSeleccionarProductoComponent } from 'src/app/views/shared/modal-seleccionar-producto/modal-seleccionar-producto.component';
import { debounceTime, filter } from 'rxjs/operators';
import { FormValidatorsService } from 'src/app/shared/services/form-validators.service';

@Component({
  selector: 'app-cotizacion-detalle',
  templateUrl: './cotizacion-detalle.component.html',
  styleUrls: ['./cotizacion-detalle.component.scss'],
  providers: [SecurityService],
})
export class CotizacionDetalleComponent implements OnInit {

  // Modales
  @ViewChild(ModalSeleccionarProductoComponent, { static: true }) modalSeleccionarProducto: ModalSeleccionarProductoComponent

  // Data &  Tmp
  private rutEmpresa: Number
  private sucursalEmpresa: Number

  // Form
  formDetails: FormGroup
  productoSeleccionado: any = null
  optionsFormato: any = []

  // Utils
  private log: any

  constructor(
    private gqlclient: GraphQLClient,
    private accesolocalstorage: SecurityService,
    private formatoProductoService: FormatoProductosService,
    private tipoDocumentoService: TipoDTEService,
    private fb: FormBuilder,
    private clog: ConsoleService,
    private toastrService: ToastService,
    private messageRendererService: MessageRendererService,
    private formValidatorsService: FormValidatorsService
  ) {
    this.log = this.clog.log('GUIA-DESPACHO-DETALLE')
  }

  ngOnInit() {
    this.rutEmpresa = this.accesolocalstorage.getRutEmpresa()
    this.sucursalEmpresa = this.accesolocalstorage.getSucursalCodigo()
    this.createForms()
    this.formChangesSubscriptions()
  }

  createForms() {
    this.formDetails = this.fb.group({
      codigoProducto: ['', [Validators.required, Validators.min(1)]],
      formato: [null, [Validators.required]],
      cantidad: [0, [Validators.required, Validators.min(1)]],
      procentajeDescuento: [0, [Validators.required, Validators.min(1)]]
    });
  }

  formChangesSubscriptions() {
    this.formDetails.get("codigoProducto").valueChanges
      .pipe(filter(Boolean), debounceTime(1000))
      .subscribe((codigo: string) => {
        this.modalSeleccionarProducto.searchBySKU(codigo)
      })
  }

  abrirModalSeleccionarProducto() {
    this.modalSeleccionarProducto.show()
  }

  onProductoSeleccionado({ data: _productoSeleccionado, origen }) {
    this.productoSeleccionado = _productoSeleccionado
    this.formDetails.get('codigoProducto').setValue(_productoSeleccionado.sku)
    this.formatoProductoService.GetFormatosByCodigo(
      this.rutEmpresa,
      this.productoSeleccionado.codigo,
      ({ mensajes, respuesta }) => {
        this.optionsFormato = respuesta.registros.map(formato => ({ value: formato.formato_codigo, label: formato.formato_nombre, ...formato }))
        this.formValidatorsService.selectDefaultFormatoProducto(this.formDetails.get('formato'), this.optionsFormato)
      }
    )
  }

  onProductoNoEncontrado() {
    this.productoSeleccionado = null
    this.optionsFormato = []
    this.formDetails.get("formato").setValue(null)
  }

  agregarProducto() {
    this.log('agregar producto')
  }

}
